import { createSlice } from "@reduxjs/toolkit";
import { EmpresaModel } from "../../../models/empresa/empresaModel";
import { ListaEmpresaDTOModel } from "../../../models/empresa/listaEmpresaDTOModel";
import { buscarEmpresa, buscarTodasEmpresa } from "../../../services/empresaService";
import { resetAll } from "../../actions/actions";

export interface EmpresaState {
  //buscar empresa
  loading: boolean;
  busca: string | null;
  list: ListaEmpresaDTOModel[];
  entity: EmpresaModel;
  //buscar todas as empresas
  loadingAll: boolean;
  listAll: ListaEmpresaDTOModel[];
  //internal
  page: string;
  modalDeletar: boolean;
  modalVisualizar: boolean;
}

const initialState: EmpresaState = {
  //buscar empresa
  loading: false,
  busca: null,
  list: [],
  entity: {} as EmpresaModel,
  //buscar todas as empresas
  loadingAll: false,
  listAll: [],
  //internal
  page: "geral",
  modalDeletar: false,
  modalVisualizar: false,
};

export const empresaSlice = createSlice({
  name: "empresa",
  initialState,
  reducers: {
    //buscar empresa
    setBuscaEmpresa: (state, action) => {
      state.busca = action.payload;
    },
    setEntityEmpresa: (state, action) => {
      state.entity = action.payload;
    },
    //buscar todas as empresas
    setLoadingTodasEmpresas: (state, action) => {
      state.loadingAll = action.payload;
    },
    setTodasEmpresas: (state, action) => {
      state.listAll = action.payload;
    },
    //internal
    setPageEmpresa: (state, action) => {
      state.page = action.payload;
    },
    setModalDeletarEmpresa: (state, action) => {
      state.modalDeletar = action.payload;
    },
    setModalVisualizarEmpresa: (state, action) => {
      state.modalVisualizar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estado
    builder.addCase(resetAll, () => initialState);

    //buscar empresa
    builder.addCase(buscarEmpresa.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarEmpresa.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarEmpresa.rejected, (state, action) => {
      state.loading = false;
    });

     //buscar todas as empresas
    builder.addCase(buscarTodasEmpresa.pending, (state) => {
      state.loadingAll = true;
    });
    builder.addCase(buscarTodasEmpresa.fulfilled, (state, action) => {
      state.listAll = action.payload;
      state.loadingAll = false;
    });
    builder.addCase(buscarTodasEmpresa.rejected, (state, action) => {
      state.loadingAll = false;
    });
  },
});

export const {
  //buscar empresa
  setBuscaEmpresa,
  setEntityEmpresa,
  //buscar todas as empresas
  setLoadingTodasEmpresas,
  setTodasEmpresas,
  //internal
  setPageEmpresa,
  setModalDeletarEmpresa,
  setModalVisualizarEmpresa,
} = empresaSlice.actions;

export default empresaSlice.reducer;
